module.exports = __webpack_public_path__ + "static/media/rightArrow.95a8cae2.svg";